import { SingleSignOnUser } from "../features/Auth";

export default function SingleSignOn() {
  return <SingleSignOnUser />;
}
